export const VIDEO_URL_REGEX =
  /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z_-]+)+((\/)[\w\d-_#]+([-_:]*[\w\d]+)*)*(.mp4|.webm|.mkv)(\?([a-zA-Z0-9_-]+=?\w?)?(&[a-zA-Z0-9_-]+=\w+)*)?$/;
